export default "__VITE_ASSET__7a5fab5e__"